module.exports = __webpack_public_path__ + "img/custom-range-calendar.5bc2d352.png";